import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/COGSInspection/COGSInspectionReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingReportCOGSInspectionActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/COGSInspection/COGSInspectionReport")
	}

	render() {
		return (
			<Activity 
				name="AccountingReportCOGSInspection"
				RenderedComponent={this.RenderedComponent}
				context="AccountingReportCOGSInspection"
				action="AccountingReportCOGSInspection"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingReportCOGSInspectionActivity)
